import StatusCodes from 'http-status-codes'
import { rest } from 'msw'

import { type Comment } from '@webapp/models/Comment'
import { type IApiV3Response } from '@webapp/services/api'
import { CommentMock } from '@webapp/tests/mocks'

export const getCommentsStub = (response?: Comment[]) => {
  return rest.get<undefined, IApiV3Response<Comment[]>>(
    '/api/v3/comments/',
    (req, res, ctx) => {
      return res(
        ctx.status(StatusCodes.OK),
        ctx.json({
          data: response ?? CommentMock.buildList(3),
        })
      )
    }
  )
}
